var HierarchicalSelect, hierarchical_select_node_comp, hierarchical_select_tree_comp;

hierarchical_select_node_comp = Vue.extend({
  name: 'hierarchical-select-node',
  props: {
    node: {
      type: Object
    },
    selectedNode: {
      type: Object
    },
    initialHiddenNode: {
      type: Object
    }
  },
  data: function() {
    return {
      expanded: false
    };
  },
  computed: {
    level: function() {
      return this.node.path.length;
    },
    // class objects
    nodeClass: function() {
      return {
        expanded: this.expanded
      };
    },
    toggleClass: function() {
      if (this.node.isLeaf) {
        return {
          'slp-empty': true
        };
      } else {
        return {
          'slp-chevron-right': !this.expanded,
          'slp-chevron-down': this.expanded
        };
      }
    },
    isHiddenNode: function() {
      var ref;
      return this.node.id !== ((ref = this.initialHiddenNode) != null ? ref.id : void 0);
    }
  },
  template: `<div class='hierarchical-select-node' :class='nodeClass' v-if="isHiddenNode">
  <div class='node-wrapper justify-between'
       @click.stop='selectNode'>
    <div class='content node-name text-ellipsis'
         :style="{ paddingLeft: (level - 1) * 1 + 'rem' }"
         @click.stop='toggleExpand'>
      <i :class='toggleClass'></i>
      <span>{{ node.name }}</span>
    </div>
    <div class="node-check" v-if="node == selectedNode">
      <i class="slp-check"></i>
    </div>
  </div>
  <div class='node-children'>
    <hierarchical-select-node
      v-for='child in node.children'
      :key='child.id'
      :node='child'
      :initialHiddenNode='initialHiddenNode'
      :selectedNode='selectedNode'
      @selectedNodeChange='selectedNodeChange'
      ref='children' />
  </div>
</div>`,
  methods: {
    selectNode: function() {
      if (this.selectedNode === this.node) {
        return this.selectedNodeChange(null);
      } else {
        return this.selectedNodeChange(this.node);
      }
    },
    toggleExpand: function() {
      this.expanded = !this.expanded;
      if (this.expanded) {
        return this._fetchChildren();
      }
    },
    selectedNodeChange: function(node) {
      return this.$emit('selectedNodeChange', node);
    },
    _fetchChildren: function() {
      if (this.node.children_count === 0) {
        return;
      }
      if (this.node.children_count === this.node.children.length) {
        return;
      }
      return Skylark.Libs.Ajax.get(`${this.node.hierarchy.resources}/${this.node.id}/children`, {
        responseType: 'json',
        success: (rawNodes) => {
          // reset(correct) children_count if children are blank
          if (_.isBlank(rawNodes)) {
            this.node.children_count = 0;
            return this.$emit('valueChanged', true);
          } else {
            rawNodes = _.filter(rawNodes, (node) => {
              var ref;
              return node.id !== ((ref = this.initialHiddenNode) != null ? ref.id : void 0);
            });
            this.node.children_count = rawNodes.length;
            return this.node.hierarchy.addNodes(rawNodes);
          }
        }
      });
    }
  }
});

hierarchical_select_tree_comp = Vue.extend({
  components: {
    'hierarchical-select-node': hierarchical_select_node_comp
  },
  template: `<div class='hierarchical-select-tree'>
  <hierarchical-select-node
    :node='tree.root'
    :selectedNode='selectedNode'
    :initialHiddenNode='initialHiddenNode'
    @selectedNodeChange='selectedNodeChange'
    ref='root' />
</div>`,
  props: {
    tree: {
      type: Object
    },
    selectedNode: {
      type: Object
    },
    initialHiddenNode: {
      type: Object
    }
  },
  methods: {
    selectedNodeChange: function(data) {
      return this.$emit('selectedNodeChange', data);
    }
  }
});

export default HierarchicalSelect = Vue.extend({
  components: {
    'hierarchical-select-tree': hierarchical_select_tree_comp
  },
  template: `<div class='hierarchical-select'>
  <div class='hierarchical-select-tree-container'>
    <hierarchical-select-tree
      v-for='tree in hierarchy.trees'
      :tree='tree'
      :key="tree.root.id"
      :selectedNode='selectedNode'
      :initialHiddenNode='initialHiddenNode'
      @selectedNodeChange='selectedNodeChange'
      ref='trees' />
  </div>
</div>`,
  props: {
    // 初始化值，支持 ID+
    initNodes: {
      type: Array
    },
    // [必填] 节点请求地址，级联选择格式
    resources: {
      type: String,
      required: true
    },
    initialHiddenNode: {
      type: Object
    }
  },
  data: function() {
    return {
      hierarchy: new Skylark.Libs.Hierarchy(),
      selectedNode: null
    };
  },
  created: function() {
    this.hierarchy.resources = this.resources;
    return this._initHierarchy(this.initNodes);
  },
  methods: {
    selectedNodeChange: function(data) {
      this.selectedNode = data;
      return this.$emit('selectedNodeChange', data);
    },
    _initHierarchy: function(ids = this.initNodes) {
      var _ids, reqUrl;
      _ids = _.map(ids, function(id) {
        return parseInt(id);
      });
      reqUrl = Skylark.Helpers.UrlHelper.generateUrlWithParams(this.resources, {
        enhanced: true,
        ids: _ids,
        include_roots: false,
        attach_ancestors: false,
        attach_siblings: false
      });
      this._setNodeParser(ids);
      return Skylark.Libs.Ajax.get(reqUrl, {
        responseType: 'json',
        success: (rsp) => {
          this.hierarchy.addNodes(_.map(rsp.data, function(node) {
            return _.omit(node, 'relationships');
          }));
          return this.hierarchy.nodeParser = function(node) {
            node._selected = false;
            return node;
          };
        }
      });
    },
    _setNodeParser: function(ids) {
      return this.hierarchy.nodeParser = function(node) {
        node._selected = false;
        return node;
      };
    }
  }
});
